import '@silvermine/videojs-chromecast/dist/silvermine-videojs-chromecast.css'
import '@silvermine/videojs-airplay/dist/silvermine-videojs-airplay.css'
import 'video.js/dist/video-js.css'
import './VideoPlayer.css'

import videoJsChromecastPlugin from '@silvermine/videojs-chromecast'
import videoJsAirplayPlugin from '@silvermine/videojs-airplay'
import React from 'react'
import videojs from 'video.js'
import VideoPlayerLive from 'components/set/InteractionPlayer/VideoPlayerLive/VideoPlayerLive'
import VideoPlayerVOD from 'components/set/InteractionPlayer/VideoPlayerVOD/VideoPlayerVOD'
import { Show } from 'data/Show'
import { Pass } from 'data/Pass'
import { Unpopulated } from 'data/Populated'
import { useAuthenticatedState } from 'libs/web-client/utils/auth0/src'

videoJsChromecastPlugin(videojs, { preloadWebComponents: true })
videoJsAirplayPlugin(videojs)

type VideoPlayerProps_<T extends 'vod' | 'live', P> = {
    type: T
    videoTitle: string
    show: Show
    passList: Unpopulated<Pass, 'show'>[]
} & P

type VideoPlayerProps =
    | VideoPlayerProps_<'live', { muted: boolean }>
    | VideoPlayerProps_<
          'vod',
          {
              src: string
              videoStartTime?: number
              disablePauseControls: boolean
              disableChromecast: boolean
              videoEndedCallback: () => void
          }
      >

const VideoPlayer: React.FC<VideoPlayerProps> = props => {
    const { user } = useAuthenticatedState()
    const viewerId = user?.email || props.passList?.find(pass => pass.show === props.show?._id)?.email || ''

    return props.type === 'vod' ? (
        <VideoPlayerVOD
            viewerId={viewerId}
            videoTitle={props.videoTitle}
            src={props.src}
            videoEndedCallback={props.videoEndedCallback}
            disablePauseControls={props.disablePauseControls}
            videoStartTime={props.videoStartTime}
            disableChromecast={props.disableChromecast}
            showId={props.show?._id}
        />
    ) : (
        <VideoPlayerLive viewerId={viewerId} videoTitle={props.videoTitle} muted={props.muted} />
    )
}

export default React.memo(VideoPlayer)
